module.exports = __webpack_public_path__ + "static/media/8_evenement.6a20375c.jpg";